/* unplugin-vue-components disabled */import script from "./ChartCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartCard.vue?vue&type=script&setup=true&lang=js"

import "./ChartCard.vue?vue&type=style&index=0&id=2797cbba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2797cbba"]])

export default __exports__